/**
 *  URL config
 *  @module Statistics
 *  @author Livescore <info@score-stats.com>
 *  @copyright 2023 livescore
 */

const conf = {
    base: 'api/table',
    api: {
        participantStandings(seasonId: number | undefined, subtournamentId: number, participantId: number): string {
            return `${conf.base}/participant-history/${seasonId}/${subtournamentId}/${participantId}`;
        },
    },
};

export default conf;
